export * from './lib/core-configuration.module';
export { ConfigService as CoreConfigService } from './lib/config.service';
export { BACKEND_SYSTEM } from './lib/config.service';
export { SpaceOneWebApiServiceURLs } from './lib/models/config.model';
